import { AngleMeasurementTool } from '@technology/web3d-plugin-markup';
import { Web3DViewerWrapper } from '@trimble/web3d-utils';
import {
  MeasurementsCapabilityProvider,
  Web3dTool,
} from '@trimble/web3d-providers';
import { SimpleMeasurementCapabilityBase } from './base-simple-measurement-capability';

export class AngleMeasurementCapability extends SimpleMeasurementCapabilityBase {
  protected measurementType: Web3dTool = Web3dTool.AngleMeasurement;

  private readonly threePickMode: boolean;

  constructor(
    measurementsProvider: MeasurementsCapabilityProvider,
    threePickMode?: boolean
  ) {
    super(measurementsProvider);
    this.threePickMode = threePickMode ?? false;
  }

  protected override async setupWeb3dMeasurementTool(
    viewerWrappers: Web3DViewerWrapper[]
  ): Promise<void> {
    await super.setupWeb3dMeasurementTool(viewerWrappers);

    for (const viewerWrapper of viewerWrappers) {
      const angleMeasurementTool =
        viewerWrapper.viewer.tools.get(AngleMeasurementTool);
      if (angleMeasurementTool) {
        angleMeasurementTool.threePickMode = this.threePickMode;
      }
    }
  }
}
